


























import {Component, Vue, Watch} from 'vue-property-decorator';
import {IOrder} from '@/models/IOrder';
import {exportOrderToExcelFile, getListOrders} from '@/services/OrderService';
import {Confirm} from '@/decorators/ConfirmDialogDecorator';
import {LayoutModule, NotificationType} from '@/store/modules/LayoutModule';
import {ModuleShop} from '@/store/modules/ShopModule';
import OrdersSelectionTable from '@/screens/dashboard/orders/OrdersSelectionTable.vue';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    OrdersSelectionTable
  }
})
export default class OrdersExportToExcelFileScreen extends Vue {
  loading: boolean = true;
  orders: IOrder[] = [];
  selectOrders: IOrder[] = [];
  exporting: boolean = false;

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.orders = (await getListOrders(this.organizationId, this.shopId)).map((order) => {
        return {
          ...order
        };
      });
    } finally {
      this.loading = false;
    }
  }

  get canExport() {
    return this.selectOrders.length > 0;
  }

  @Confirm('Confirmation', 'Are you sure to export?')
  async exportOrders() {
    try {
      this.exporting = true;
      const orders = this.selectOrders.map((order) => ({
        id: order.id
      }));
      const result = await exportOrderToExcelFile(this.organizationId, this.shopId, orders);
      if (result) {
        LayoutModule.showNotification({text: 'Export successfully!'});
        this.$router.back();
      } else {
        LayoutModule.showNotification({text: 'Export error!', type: NotificationType.ERROR});
      }
    } finally {
      this.exporting = false;
    }
  }
}
